import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface generateCodeForDeviceState {
  isGenerateCodeLoading: boolean;
  isGenerateCodeError: any | null;
  generateForDevice: unknown | null;
}

const initialState: generateCodeForDeviceState = {
  isGenerateCodeLoading: false,
  isGenerateCodeError: null,
  generateForDevice: null,
};

const generateCodeForDeviceSlice = createSlice({
  name: 'generateCode',
  initialState,
  reducers: {
    // fetch generate code for device status
    generateCodeForDeviceRequest(state, action: PayloadAction<any>) {
      state.isGenerateCodeLoading = true;
      state.isGenerateCodeError = null;
    },
    generateCodeForDeviceSuccess(state, action: PayloadAction<any>) {
      state.isGenerateCodeLoading = false;
      state.generateForDevice = action.payload;
      state.isGenerateCodeError = null;
    },
    generateCodeForDeviceFailure(state, action: PayloadAction<any>) {
      state.isGenerateCodeLoading = false;
      state.isGenerateCodeError = action.payload;
    },
    resetGenerateCode(state, action: PayloadAction<any>) {
      state.isGenerateCodeLoading = false;
      state.generateForDevice = null;
      state.isGenerateCodeError = null;
    },
    resetGenerateCodeDeviceSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  generateCodeForDeviceRequest,
  generateCodeForDeviceSuccess,
  generateCodeForDeviceFailure,
  resetGenerateCode,
  resetGenerateCodeDeviceSlice,
} = generateCodeForDeviceSlice.actions;

export default generateCodeForDeviceSlice.reducer;
